//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconRatingWinkAlt(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.5 9.75C17.4665 9.75 18.25 8.9665 18.25 8C18.25 7.0335 17.4665 6.25 16.5 6.25C15.5335 6.25 14.75 7.0335 14.75 8C14.75 8.9665 15.5335 9.75 16.5 9.75Z" fill="currentColor" /><path d="M18.2799 12.95C16.7399 14.89 14.4599 16 11.9999 16C9.5399 16 7.2599 14.89 5.7199 12.95L4.1499 14.19C6.0699 16.61 8.9299 18 11.9999 18C15.0699 18 17.9299 16.61 19.8399 14.19L18.2799 12.95Z" fill="currentColor" /><path d="M10 7H6V9H10V7Z" fill="currentColor" /></svg>;
}
export default IconRatingWinkAlt;